
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { formatPrice } from "@/lib/utils";

interface UnenrolledViewProps {
  course: any;
  onPurchase: () => void;
}

const UnenrolledView = ({ course, onPurchase }: UnenrolledViewProps) => {
  const price = course.price ? formatPrice(course.price) : "0.00";
  
  return (
    <Card className="overflow-hidden">
      <div className="bg-primary text-white p-4 text-center">
        <h3 className="text-lg font-bold">Osta kursus</h3>
        <p className="text-2xl font-bold mt-2">{price} €</p>
      </div>
      
      <CardContent className="p-6 space-y-6">
        <div className="space-y-3">
          <div className="flex items-center">
            <svg className="h-5 w-5 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span>Ligipääs kõigile õppematerjalidele</span>
          </div>
          
          <div className="flex items-center">
            <svg className="h-5 w-5 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span>Videoloengud ja harjutused</span>
          </div>
          
          <div className="flex items-center">
            <svg className="h-5 w-5 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span>Õpi sobivas tempos</span>
          </div>
        </div>
        
        <Button 
          className="w-full bg-primary hover:bg-primary/90 text-white font-medium py-2 rounded"
          onClick={onPurchase}
        >
          Osta kohe
        </Button>
        
        <p className="text-xs text-center text-gray-500">
          Turvaline makse. Kohene juurdepääs pärast ostu.
        </p>
      </CardContent>
    </Card>
  );
};

export default UnenrolledView;
